import React, { useState, useEffect } from "react"
import ASN from '../services/ASN'
import PO from '../services/PO'
import SecondaryASNFilterDropdown from './secondaryASNFilterDropdown'
import Loading from "../loading/Loading"

export interface singleModeOption { displayName: string, value: string };

interface Props {
  lpId: number;
  setFilterValue: (option: string) => void;
  setPrimaryFilterValue: (option: string) => void;
  singleMode: singleModeOption;  
}

const PrimaryASNFilterDropdown = (props: Props) => {
  const [showSecondaryFilter, setShowSecondaryFilter] = useState(props.singleMode ? true : false);
  const [primaryFilterValue, setPrimaryFilterValue] = useState(!props.singleMode ? "none" : props.singleMode.value);
  const [loading, setLoading] = useState(false);
  const [options, setOptions] = useState([] as JSX.Element[]);
  const [firstOption, setFirstOption] = useState('none');

  useEffect(() => {
    buildOptions(primaryFilterValue);
  }, [primaryFilterValue]);

  const onFilterDropdownChange = async (e: React.FormEvent) => {
    const target = e.target as HTMLSelectElement;
    const value: string = target.value;

    if (target.value !== 'no filter') {      
      setPrimaryFilterValue(value);
      setShowSecondaryFilter(true);
      setLoading(true);

      await buildOptions(value)

    } else {
      setPrimaryFilterValue(value);
      setShowSecondaryFilter(false);
    }

    props.setPrimaryFilterValue(primaryFilterValue);
  }

  const getASNNumbers = () => {
    return ASN.getList(props.lpId, 0, 'none', [{ refiner: 'default', value: 'none' }], false).then((response) => {
      const asnValues =  response.content.value;
      const asnNumbers = asnValues.map((asn: any) => {
        return asn.asnNumber.trim()
      }).filter((asnNumber: string) => asnNumber.length > 0)
      return asnNumbers.length > 0 ? asnNumbers : ['No ASN Numbers'];
    })
  }



  const getPONumbers = () => {
    if (props.lpId !== undefined && props.lpId !== null ) {
      return PO.getList(props.lpId).then((response) => {
        return response.content.value.map((poId: any) => {
          return poId.value.trim()
        });
      })
    } else {
      throw Error('Missing Lp value')
    }

  }


  const buildOptions = async (primaryFilter: string) => {    
    let options: string[] = [];
    // if (this.state.primaryFilterValue !== "none") {
      switch(primaryFilter.toLowerCase()) {
        case "none":
          setShowSecondaryFilter(false);

          break
        case "ponumber":
          options = await getPONumbers()
          break
        case "asnnumber":
          options = await getASNNumbers()
          break
        default:
          options =
           ['BOOKED', 'SUBMITTED', 'DRAFT', 'REMOVED', 'RECEIVED', 'PREBOOKED']
           break
      }      

    const elements: JSX.Element[] = [<option key="None" value=""></option>].concat(options.map((item: string) => {
      return (
        <option key={`${item}`} value={`${item}`}>
          {`${item}`}
        </option>);
    }));      

    setLoading(false);
    setOptions(elements);
    setFirstOption(options[0]);
  }

  const buildSecondaryFilterDropdown = () => {

    if (showSecondaryFilter && !loading) {
      return (

          <SecondaryASNFilterDropdown
            options={options}
            initialOption={firstOption}
            lp={props.lpId}
          label={props.singleMode ? props.singleMode.displayName : primaryFilterValue}
            selectFunction={props.setFilterValue}
          />
      )
    } else if  (loading) {
      return (
        <Loading show={true}/>
      );
    }
  }

  return <div className="col-md">
      {props.singleMode ? "" : <div className="form-group">
        <label htmlFor="exampleFormControlSelect1">Filter By</label>
        <select
          onChange={(e) => onFilterDropdownChange(e)}
          className="form-control"
          id="exampleFormControlSelect1">
          <option value="none">No Filter</option>
          <option value="asnnumber">ASN Number</option>
          <option value="orderstatus">Order Status</option>
          <option value="ponumber">PO Number</option>
        </select>
      </div>}
      {buildSecondaryFilterDropdown()}
    </div>;
}

export default PrimaryASNFilterDropdown
